<script>
  import { onMount } from "svelte";
  import { Button, Pagination, PaginationItem } from "sveltestrap";

  export let current;
  export let total;
  export let xpage; // Items per page
  export let onPageClick;

  let pages = [1];

  onMount(() => {
    console.log("[Paginator] onMount - inicializando paginación");
    generatePageRange();
  });

  $: {
    console.log("[Paginator] Props actualizadas:", { current, total, xpage });
    generatePageRange();
  }

  function generatePageRange() {
    console.log("[Paginator] Generando rango de páginas...");
    if (total > 0 && xpage > 0) {
      const totalPages = Math.ceil(total / xpage);
      const visiblePages = 5;
      const middle = Math.floor(visiblePages / 2);

      let startPage = current - middle;
      let endPage = current + middle;

      if (startPage < 1) {
        startPage = 1;
        endPage = Math.min(totalPages, visiblePages);
      }

      if (endPage > totalPages) {
        endPage = totalPages;
        startPage = Math.max(1, totalPages - visiblePages + 1);
      }

      const range = [];
      for (let i = startPage; i <= endPage; i++) {
        range.push(i);
      }

      console.log("[Paginator] totalPages:", totalPages);
      console.log("[Paginator] startPage:", startPage, "endPage:", endPage);
      console.log("[Paginator] páginas a mostrar:", range);

      pages = range;
    } else {
      console.log("[Paginator] valor inválido para total o items per page");
      pages = [1];
    }
  }
</script>


<nav class="pagination">
  <span class="total-info">Total {total} items.</span>

  <Pagination>
    <PaginationItem disabled={current === 1}>
      <Button class="page-link" on:click={() => onPageClick(current - 1)}>
        <span aria-hidden="true">&laquo;</span>
      </Button>
    </PaginationItem>

    {#each pages as page}
      <PaginationItem active={current === page}>
        <Button class="page-link" on:click={() => onPageClick(page)}>
          {page}
        </Button>
      </PaginationItem>
    {/each}

    <PaginationItem disabled={current === Math.ceil(total / xpage)}>
      <Button class="page-link" on:click={() => onPageClick(current + 1)}>
        <span aria-hidden="true">&raquo;</span>
      </Button>
    </PaginationItem>
  </Pagination>
</nav>

<style>
  .pagination {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 1em 0;
  }
  .total-info {
    color: black;
    margin-right: 1em;
  }
  @media (max-width: 768px) {
    .pagination {
      flex-wrap: wrap;
    }
  }
</style>